import { BillingMenuAside } from "./style";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "react-material-symbols/sharp";
import BillingMenuButton from "./components/menu_button";

const BillingMenu: React.FC = () => {
  const location = useLocation();
  const [page, setPage] = useState("");
  const [topScroll, setTopScroll] = useState(64);

  useEffect(() => {
    setPage(location.pathname);
  });

  window.addEventListener("scroll", function () {
    if (window.scrollY <= 64) {
      setTopScroll(64 - document.documentElement.scrollTop);
    } else {
      setTopScroll(0);
    }
  });
  return (
    <BillingMenuAside top={topScroll}>
      <BillingMenuButton page={page} icon="home" name="Home" path="/" />

      <BillingMenuButton page={page} icon="description" name="Contrato" path="/contrato" />
      <BillingMenuButton page={page} icon="note_add" name="Cadastros" path="/cadastro" />
      <BillingMenuButton page={page} icon="payments" name="Faturamento" path="/faturamento" />
    </BillingMenuAside>
  );
};

export default BillingMenu;
